export const parseData = (data: any) => {
  const parsedData = data.map((obj: any) => {
    try {
      const parsedContent = JSON.parse(obj.content);
      return { ...obj, content: parsedContent }; // Return new object with parsed content
    } catch (error) {
      console.error('JSON parsing error:', error);
      return { ...obj, content: null }; // Handle parsing errors
    }
  });

  return parsedData;
};
